module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "border-radius": "16px"
    }
  }, [_c('div', {
    staticClass: "media-list"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "bottom"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 22
    }
  }, [_c('div', {
    staticClass: "breadcrumb-bar"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("音频资源上传")])], 1)], 1)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "tableList"
  }, [_c('el-form', {
    staticClass: "searchForm",
    attrs: {
      "inline": true,
      "model": _vm.formResource,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资源专辑名称"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.formResource.name),
      callback: function($$v) {
        _vm.$set(_vm.formResource, "name", $$v)
      },
      expression: "formResource.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), (!isNaN(parseInt(_vm.percentage))) ? _c('el-progress', {
    staticClass: "class_progerss",
    attrs: {
      "percentage": _vm.percentage,
      "color": _vm.customColor,
      "format": _vm.formatProgress
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "operBtn"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus"
    },
    on: {
      "click": _vm.addAlbum
    }
  }, [_vm._v("新建专辑")])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.desc == 'addResource' ? '新建专辑' : '编辑专辑',
      "visible": _vm.dialogVisible,
      "center": "",
      "width": "40%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.formFuzzy,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "资源名称:"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "220px"
    },
    attrs: {
      "placeholder": "输入名称"
    },
    model: {
      value: (_vm.formFuzzy.name),
      callback: function($$v) {
        _vm.$set(_vm.formFuzzy, "name", $$v)
      },
      expression: "formFuzzy.name"
    }
  })], 1)], 1), _vm._v(" "), (_vm.desc == 'addResource') ? _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.addResource
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "initial",
      "font-size": "14px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('span', [_vm._v("我已同意并阅读")]), _c('a', {
    staticStyle: {
      "color": "#2d8cf0"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.lookKnowLedge
    }
  }, [_vm._v("《知识产权承诺》")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.desc == 'editResource') ? _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editResource(_vm.ids)
      }
    }
  }, [_vm._v("下一步")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "text-align": "initial",
      "font-size": "14px"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }), _vm._v(" "), _c('span', [_vm._v("我已同意并阅读")]), _c('a', {
    staticStyle: {
      "color": "#2d8cf0"
    },
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.lookKnowLedge
    }
  }, [_vm._v("《知识产权承诺》")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.cenceldialogVisible,
      "center": "",
      "width": "50%",
      "title": "《知识产权承诺》"
    },
    on: {
      "update:visible": function($event) {
        _vm.cenceldialogVisible = $event
      }
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "30px",
      "line-height": "32px",
      "font-size": "15px"
    }
  }, [_vm._v("\n        您承诺并保证，您在“FanReading”及“听力熊”移动客户端以各种形式发布的信息，均符合《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国反不正当竞争法》、《中华人民共和国侵权责任法》、《中华人民共和国广告法》、《中华人民共和国计算机信息系统安全保护条例》、《计算机软件保护条例》及《信息网络传播权保护条例》等有关法律、法规、规章的规定。\n      ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "30px",
      "line-height": "32px",
      "font-size": "15px"
    }
  }, [_vm._v("\n        您承诺并保证，在“FanReading”及“听力熊”移动客户端以各种形式发布的信息，均符合社会公序良俗；所上传的文字、图片、音频、多媒体资料或其他内容均拥有相应合法的权利。\n      ")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.cenceldialogVisible = false
      }
    }
  }, [_vm._v("知道了")])], 1)]), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading.body",
      value: (_vm.loading),
      expression: "loading",
      modifiers: {
        "body": true
      }
    }],
    ref: "multipleTable",
    attrs: {
      "data": _vm.queryData,
      "header-cell-style": _vm.rowClass,
      "tooltip-effect": "dark",
      "id": "Table"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "资源专辑ID",
      "align": "center",
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "资源专辑名称",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "res_count",
      "label": "数量",
      "align": "center",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "updated_at",
      "label": "更新时间",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("formatDate2")(scope.row.updated_at)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "layerType",
      "label": "专辑类型",
      "align": "center",
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.layerType == 2) ? _c('span', [_vm._v("多层专辑")]) : _vm._e(), _vm._v(" "), (scope.row.layerType == 1) ? _c('span', [_vm._v("单层专辑")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": "状态",
      "align": "center",
      "min-width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger"
          }
        }, [_vm._v("未上架")]) : (scope.row.status == 1) ? _c('el-tag', {
          attrs: {
            "type": "gray"
          }
        }, [_vm._v("已上架")]) : (scope.row.status == 2) ? _c('el-tag', {
          attrs: {
            "type": "success"
          }
        }, [_vm._v("被下架")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "show-overflow-tooltip": "",
      "align": "center",
      "width": "100",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "编辑",
            "placement": "top"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "mini",
            "icon": "el-icon-edit"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.row)
            }
          }
        })], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "bottomOperBtn"
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "danger",
      "icon": "delete2"
    },
    on: {
      "click": _vm.delResource
    }
  }, [_vm._v("删除")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "primary",
      "icon": "arrow-up"
    },
    on: {
      "click": _vm.upResource
    }
  }, [_vm._v("上架")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "info",
      "icon": "arrow-down"
    },
    on: {
      "click": _vm.downResource
    }
  }, [_vm._v("下架")])], 1), _vm._v(" "), _c('div', {
    staticClass: "pagination-box"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.queryParams.page,
      "page-sizes": [20, 50, 100],
      "page-size": _vm.queryParams.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.pageTotal
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.queryParams, "page", $event)
      }
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3456df28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/audioResources.vue
// module id = 675
// module chunks = 1